var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxsFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-file-pdf",
    transform: "translate(-8 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44870",
    "data-name": "Path 44870",
    d: "M16.162,29.36a1.5,1.5,0,0,0-.372.036v1.178a1.362,1.362,0,0,0,.3.023c.479,0,.774-.242.774-.651C16.866,29.58,16.612,29.36,16.162,29.36Zm3.487.012a1.845,1.845,0,0,0-.407.036v2.61a1.633,1.633,0,0,0,.313.018,1.236,1.236,0,0,0,1.349-1.4,1.144,1.144,0,0,0-1.255-1.268Z",
    transform: "translate(-3.895 -12.68)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44871",
    "data-name": "Path 44871",
    d: "M18,4H10A2,2,0,0,0,8,6V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10ZM13.5,18.19a1.854,1.854,0,0,1-1.3.42,2.23,2.23,0,0,1-.308-.018v1.426H11V16.082A7.558,7.558,0,0,1,12.219,16a1.917,1.917,0,0,1,1.22.319,1.169,1.169,0,0,1,.426.923A1.282,1.282,0,0,1,13.5,18.19Zm3.807,1.355a2.863,2.863,0,0,1-1.84.515A7.7,7.7,0,0,1,14.441,20V16.083A7.947,7.947,0,0,1,15.66,16a2.564,2.564,0,0,1,1.633.426,1.764,1.764,0,0,1,.675,1.5A2.024,2.024,0,0,1,17.305,19.545ZM21,16.77H19.468v.911H20.9v.734H19.468v1.6h-.906V16.03H21ZM18,11H17V6l5,5Z",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsFilePdf);
export default __webpack_public_path__ + "static/media/bxs-file-pdf.08bd1ebb47faee2f3a7b8b058b41f891.svg";
export { ForwardRef as ReactComponent };